export default __webpack_public_path__ + "static/media/marcy kaptur.0ae9ea3f.jpg";